export default "__VITE_ASSET__ChlCeKUP__"